module.exports = __webpack_public_path__ + "img/speaker-l3.8f2e1289.jpg";